<template>
  <List
    envName="种植环境"
    :envInfoType="1" />
</template>

<script>
import List from '@/components/business/traceinfo/list'
export default {
  name: 'PlatEnvList',
  components: { List },
  props: {},
  data() {
    return {}
  },
  computed: {},
  watch: {},
  created() { },
  mounted() { },
  methods: {}
}
</script>
<style lang="stylus" scoped></style>
